module.exports = __webpack_public_path__ + "img/profiles.467ed31.webp";